import { ApexApiError } from 'apex-ui-services'
import { updatePhone as updatePhoneApi } from '../api'
import { HttpResponseStatusCodes } from '../constants'
import { PhoneNumber } from '../types/CommonTypes'
import { TEMPORARILY_UNAVAILABLE, ACCOUNT_UPDATE_FAILED } from './constants'

export const updatePhone = (
  accountNumber: string,
  phoneNumbers: PhoneNumber[],
  onError: (error: string) => void,
  onSuccess: () => void
) => {
  updatePhoneApi(accountNumber, phoneNumbers)
    .then(onSuccess)
    .catch((error: ApexApiError) => {
      // Won't display a toast if user just doesn't have permissions
      const httpResponseStatus = error.response?.status
      if (
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
      ) {
        onError(TEMPORARILY_UNAVAILABLE)
      } else if (httpResponseStatus === HttpResponseStatusCodes.Forbidden) {
        onError(ACCOUNT_UPDATE_FAILED)
      }
    })
}
